// ============================================================
// SAYFA REHBERI KARTI
//
// Her panel sayfasinin ustunde duran aciklama karti: sayfanin ne
// yonettigi, UYGULAMADA NEREYE denk geldigi ve her alanin ne ise
// yaradigi. Icerik helpers/panelRehberi.js icinde.
//
// Kullanim:  <SayfaRehberi sayfa="slider" />
//
// Kart varsayilan olarak ACIK gelir; kullanici kapatirsa tercihi
// tarayicida saklanir (sayfa bazinda), her acilista tekrar
// kapatmak zorunda kalmaz.
// ============================================================

import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { sayfaRehberiniGetir } from "../../helpers/panelRehberi";

const ANAHTAR = sayfa => `sayfaRehberi:${sayfa}`;

const kapaliMi = sayfa => {
  try {
    return localStorage.getItem(ANAHTAR(sayfa)) === "kapali";
  } catch (e) {
    return false;
  }
};

const SayfaRehberi = ({ sayfa }) => {
  const rehber = sayfaRehberiniGetir(sayfa);
  const [acik, setAcik] = useState(() => !kapaliMi(sayfa));

  const cevir = useCallback(() => {
    setAcik(onceki => {
      const yeni = !onceki;
      try {
        localStorage.setItem(ANAHTAR(sayfa), yeni ? "acik" : "kapali");
      } catch (e) {
        /* saklanamazsa sorun degil */
      }
      return yeni;
    });
  }, [sayfa]);

  // Rehber yazilmamis sayfalarda hicbir sey cizme
  if (!rehber) return null;

  return (
    <div className={"sayfa-rehberi" + (acik ? "" : " kapali")}>
      <button type="button" className="sayfa-rehberi-baslik" onClick={cevir}>
        <span className="sayfa-rehberi-ikon">
          <i className="bx bx-info-circle" />
        </span>
        <span className="sayfa-rehberi-ozet">
          <b>Bu sayfa ne işe yarar?</b>
          <span>{rehber.ozet}</span>
        </span>
        <span className="sayfa-rehberi-cevir">
          {acik ? "Gizle" : "Göster"}
          <i className={acik ? "bx bx-chevron-up" : "bx bx-chevron-down"} />
        </span>
      </button>

      {acik && (
        <div className="sayfa-rehberi-govde">
          {rehber.nerede ? (
            <div className="sayfa-rehberi-yer">
              <i className="bx bx-mobile-alt" />
              <span>
                <b>Uygulamada nerede:</b> {rehber.nerede}
              </span>
            </div>
          ) : null}

          {rehber.uyari ? (
            <div className="sayfa-rehberi-uyari">
              <i className="bx bx-error" />
              <span>{rehber.uyari}</span>
            </div>
          ) : null}

          {rehber.alanlar && rehber.alanlar.length ? (
            <>
              <div className="sayfa-rehberi-alt-baslik">Alanlar ne işe yarar</div>
              <dl className="sayfa-rehberi-alanlar">
                {rehber.alanlar.map(([ad, aciklama]) => (
                  <div key={ad}>
                    <dt>{ad}</dt>
                    <dd>{aciklama}</dd>
                  </div>
                ))}
              </dl>
            </>
          ) : null}

          {rehber.ipuclari && rehber.ipuclari.length ? (
            <ul className="sayfa-rehberi-ipuclari">
              {rehber.ipuclari.map(ipucu => (
                <li key={ipucu}>{ipucu}</li>
              ))}
            </ul>
          ) : null}

          <a
            className="sayfa-rehberi-link"
            href="/kilavuz.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ayrıntılı kullanım kılavuzu <i className="bx bx-link-external" />
          </a>
        </div>
      )}
    </div>
  );
};

SayfaRehberi.propTypes = {
  sayfa: PropTypes.string.isRequired,
};

export default SayfaRehberi;
